import Nav from "react-bootstrap/Nav";
import { Link, useLocation } from "react-router-dom";
import "./Tabs.css";
import { Button } from "react-bootstrap";
const styles = {
  activeTab: {
    borderBottom: "3px solid #375EAD",
    color: "#375EAD",
    fontWeight: "bold",
    fontSize: "14px",
  },

  deactiveTab: {
    color: "rgba(30, 30, 30, 0.53)",
    fontWeight: "600",
    fontSize: "14px",
  },
  backButton: {
    background: "transparent",
    border: "none",
    fontWeight: "bold",
    color: "#000078",
    cursor: "pointer",
    alignItems: "center",
    padding: "15px 00px",
    boxShadow: "none",
  },
};
function HistoryTabs(props) {
  const path = useLocation();
  console.log("Bill for", props.tabsfor);
  return (
    <div
      style={{
        marginTop: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Nav
          id="water-tabs"
          variant="tabs"
          justify
          defaultActiveKey={
            path.pathname === "/history"
              ? "/history"
              : path.pathname === "/monthhistory"
              ? "/monthhistory"
              : null
          }
        >
          <Nav.Item className="navItem">
            <Nav.Link
              id="navLink"
              style={
                path.pathname === "/history"
                  ? styles.activeTab
                  : styles.deactiveTab
              }
              eventKey="/history"
              href="/history"
            >
              Yearly Reports
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="navItem">
            <Nav.Link
              id="navLink"
              style={
                path.pathname === "/monthhistory"
                  ? styles.activeTab
                  : styles.deactiveTab
              }
              eventKey="/monthhistory"
              href="/monthhistory"
            >
              Monthly Reports
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
}

export default HistoryTabs;
